import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getAdminAuthConfig = () => {
  const password = localStorage.getItem('idmat_admin');
  return {
    headers: {
      Authorization: `Basic ${btoa(`admin:${password || ''}`)}`,
    },
  };
};

export const adminGet = async (path) => {
  const response = await axios.get(`${API}${path}`, getAdminAuthConfig());
  return response.data;
};

export const adminPost = async (path, payload) => {
  const response = await axios.post(`${API}${path}`, payload, getAdminAuthConfig());
  return response.data;
};

export const adminPut = async (path, payload) => {
  const response = await axios.put(`${API}${path}`, payload, getAdminAuthConfig());
  return response.data;
};

export const adminDelete = async (path) => {
  const response = await axios.delete(`${API}${path}`, getAdminAuthConfig());
  return response.data;
};
